'use strict';

// Import Libraries
import React from 'react';
import PropTypes  from 'prop-types';
// Import JSX Modules
import PricesTable from './prices-table';

// -----------------------------------------------------------
//  ProductDescription
// -----------------------------------------------------------
const ProductDescription = ({currentProduct, products, deliveryOptions}, {showPricesTable, description}) => {
  description = (currentProduct && currentProduct.description) || description;

  if (showPricesTable) {
    return (
      <div className="product-description">
        <div className="row">
          <div className="col-md-6 col-12" dangerouslySetInnerHTML={{__html: description}} />
          <div className="col-md-6 col-12">
            <PricesTable products={ products } delivery_options={ deliveryOptions } />
          </div>
        </div>
      </div>
    );
  }

  if (description) {
    return (
      <div className="row">
        <div className="col-12 col-sm-12 col-md-8">
          <div className="product-description" dangerouslySetInnerHTML={{__html: description}} />
        </div>
      </div>
    );
  }

  return null;
};

ProductDescription.contextTypes = {
  description: PropTypes.string,
  showPricesTable: PropTypes.bool
}

export default ProductDescription;
